const subAbas = [{ label: 'Início', rota: '/ses/home/inicio' }];

export default subAbas;
